import React from "react";
import { useNavigate } from "react-router-dom";

import {
  FiArrowLeft,
  FiArrowRight,
} from "react-icons/fi";

import {
  HiOutlineDocumentDuplicate,
} from "react-icons/hi2";

import { LuSend } from "react-icons/lu";

const FormFooter = ({
  activeStep = 1,
  totalSteps = 3,
  onContinue,
  onBack,
  onPublish,
  onSaveDraft,
  publishing = false,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex justify-content-between align-items-center px-4 py-3 bg-white border-top"
      style={{
        position: "sticky",
        bottom: 0,
        zIndex: 100,
      }}
    >
      {/* LEFT */}
      <div>
        {activeStep === 1 ? (
          <button
            type="button"
            className="btn px-4 fw-semibold"
            style={{
              border: "1px solid #E5E7EB",
              color: "#000",
              backgroundColor: "#fff",
              boxShadow: "none",
            }}
            onClick={() => navigate("/offers")}
          >
            Cancel
          </button>
        ) : (
          <button
            type="button"
            onClick={onBack}
            className="btn px-4 fw-semibold"
            style={{
              border: "1px solid #E5E7EB",
              color: "#000",
              backgroundColor: "#fff",
              boxShadow: "none",
            }}
          >
            <FiArrowLeft className="me-2" />
            Back
          </button>
        )}
      </div>

      {/* RIGHT */}
      <div className="d-flex align-items-center gap-3">
        {/* PROGRESS */}
        <div className="d-flex align-items-center gap-2">
          {Array.from({
            length: totalSteps,
          }).map((_, index) => {
            const step = index + 1;

            return (
              <span
                key={step}
                style={{
                  width:
                    step === activeStep
                      ? 22
                      : 8,

                  height: 8,

                  borderRadius: 20,

                  background:
                    step < activeStep
                      ? "#1abc84"
                      : step === activeStep
                        ? "var(--rv-primary-color)"
                        : "#d9d9d9",

                  transition: ".3s",
                }}
              />
            );
          })}
        </div>

        {/* LAST STEP */}
        {activeStep === totalSteps ? (
          <>
            <button
              type="button"
              className="btn px-4 fw-semibold"
              style={{
                border: "1px solid #E5E7EB",
                color: "#000",
                backgroundColor: "#fff",
              }}
              onClick={onSaveDraft}
              disabled={publishing}
            >
              <HiOutlineDocumentDuplicate className="me-2" />
              Save Draft
            </button>

            <button
              type="button"
              className="btn text-white px-4 fw-semibold"
              style={{
                background:
                  "var(--rv-primary-color)",
                minWidth: 170,
              }}
              onClick={onPublish}
              disabled={publishing}
            >
              <LuSend className="me-2" />

              {publishing
                ? "Publishing..."
                : "Publish Offer"}
            </button>
          </>
        ) : (
          <button
            type="button"
            className="btn text-white px-4 fw-semibold"
            style={{
              background:
                "var(--rv-primary-color)",
              minWidth: 150,
            }}
            onClick={onContinue}
          >
            Continue
            <FiArrowRight className="ms-2" />
          </button>
        )}
      </div>
    </div>
  );
};

export default FormFooter;